/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {DropZoneDirective as ɵa} from './lib/directives/drop-zone/drop-zone.directive';